<template>
    <RouterView v-slot="{ Component }">
        <Transition name="fade-slide" mode="out-in">
            <component :is="Component" />
        </Transition>
    </RouterView>
    <!-- App-wide "Please wait" loader, driven by the singleton loader state / window.showLoader. -->
    <LoaderOverlay :show="show" :title="title" :text="text" :button="button" :url="url ?? ''" :light="light" />
    <!-- Blocks the journey when the same quote is already open in another tab (see useTabLock). -->
    <TabLockOverlay v-if="tabBlocked" />
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import LoaderOverlay from '@/components/Common/LoaderOverlay.vue'
import TabLockOverlay from '@/components/Common/TabLockOverlay.vue'
import { useLoader } from '@/composables/useLoader'
import { useTabLock } from '@/composables/useTabLock'

const { show, title, text, button, url, light, showLoader, hideLoader } = useLoader()
// One retail quote/payment flow per browser — a second tab is blocked (shared lock with the payment page).
const { blocked: tabBlocked } = useTabLock('retail-quote')

// Expose the global hooks the quote flow already calls (SingleScheme re-rate, useReviewApi, Factory).
onMounted(() => {
    ;(window as any).showLoader = showLoader
    ;(window as any).hideLoader = hideLoader
})
</script>
